/**
 * English SEO landing pages targeting international customers in Denmark.
 * Routes: /en/courier-{slug}
 * Targets searches like "courier Copenhagen", "same-day delivery Copenhagen",
 * "English-speaking courier Denmark", "express courier Copenhagen".
 */
export const EN_CITIES = {
  copenhagen: {
    slug: "copenhagen",
    name: "Copenhagen",
    daSlug: "koebenhavn",
    zip: "1050",
    headline: "Same-Day Courier in Copenhagen",
    tagline: "Premium direct courier service · No warehouse, no transhipment · Same-day, express and evening delivery across Greater Copenhagen.",
    intro:
      "EMA Kurer is a Danish premium courier company serving Copenhagen and the rest of Zealand. We pick up directly from you and drive straight to the recipient — no warehouse, no transhipment, no waiting. We work with embassies, international companies, expat-focused webshops and private customers who need fast, reliable, English-speaking service.",
    placeholderFrom: "Hovedbanegården, 1577 Copenhagen V",
    placeholderTo: "Strøget 12, 1160 Copenhagen K",
    deliveryZones: ["1050 Copenhagen K", "2100 Copenhagen Ø", "2300 Copenhagen S", "2400 Copenhagen NV", "2500 Valby", "2700 Brønshøj", "2200 Copenhagen N"],
    nearby: ["roskilde", "helsingor"],
    useCases: [
      { t: "Embassies & consulates", d: "Discreet, secure document delivery with photo proof of delivery." },
      { t: "International companies", d: "English-speaking driver, transparent pricing in DKK, monthly invoicing available." },
      { t: "Expat webshops", d: "Same-day delivery to your customers anywhere in Greater Copenhagen — order before 18:00." },
      { t: "Private customers", d: "Forgot something at home? Need a gift delivered fast? We pick up and drive directly." },
    ],
    faq: [
      { q: "How much does a courier in Copenhagen cost?", a: "Same-Day Courier starts at 199 DKK (~€27) including 8 km. Extra distance is 6 DKK per km. A typical Copenhagen delivery costs 199-250 DKK including 25% Danish VAT." },
      { q: "Do you offer English-speaking service?", a: "Yes — our drivers and support team speak English. All booking, tracking and customer service is available in both Danish and English." },
      { q: "How fast can you pick up in Copenhagen?", a: "Same-Day: typically 60-90 minutes after booking. Express: 30-60 minutes. Evening delivery (18:00-22:00) is ideal when the recipient is only home after work." },
      { q: "Which payment methods do you accept?", a: "Credit card, Apple Pay, Google Pay, MobilePay and EAN/CVR invoicing for business customers." },
      { q: "What areas of Copenhagen do you cover?", a: "All of Copenhagen (1000- and 2000-series postal codes), Frederiksberg, Amager, plus the entire island of Zealand." },
    ],
  },
  roskilde: {
    slug: "roskilde",
    name: "Roskilde",
    daSlug: "roskilde",
    zip: "4000",
    headline: "Same-Day Courier in Roskilde",
    tagline: "Direct courier service in Roskilde and Greater Copenhagen — for international companies and private customers.",
    intro:
      "EMA Kurer offers premium courier service in Roskilde and the surrounding region. We're often used by Risø, biotech companies and international firms in the Roskilde area who need same-day, English-speaking, reliable delivery.",
    placeholderFrom: "Algade 31, 4000 Roskilde",
    placeholderTo: "Havnen 8, 4000 Roskilde",
    deliveryZones: ["4000 Roskilde", "4030 Tune", "4040 Jyllinge", "4050 Skibby", "4070 Kirke Hyllinge"],
    nearby: ["copenhagen", "helsingor"],
    useCases: [
      { t: "Biotech & research", d: "Discreet transport of samples and equipment with full tracking." },
      { t: "International offices in Roskilde", d: "English-speaking service for documents and parcels." },
      { t: "Same-day to Copenhagen", d: "Roskilde → Copenhagen on 33 km — same-day delivery from ~349 DKK." },
    ],
    faq: [
      { q: "How much is a Roskilde courier?", a: "Same-Day starts at 199 DKK (~€27) including 8 km. Local Roskilde deliveries typically 199-220 DKK." },
      { q: "Can you drive between Roskilde and Copenhagen?", a: "Yes — it's one of our most common routes. Roskilde to Copenhagen (~33 km) costs about 349 DKK Same-Day." },
    ],
  },
  helsingor: {
    slug: "helsingor",
    name: "Helsingør (Elsinore)",
    daSlug: "helsingoer",
    zip: "3000",
    headline: "Same-Day Courier in Helsingør (Elsinore)",
    tagline: "Premium courier service in Helsingør and Northern Zealand — including ferry-port deliveries to/from Sweden.",
    intro:
      "EMA Kurer delivers professional courier service in Helsingør (known internationally as Elsinore — Hamlet's castle is here) and Northern Zealand. We're frequently used for cross-border ferry deliveries to Helsingborg, Sweden.",
    placeholderFrom: "Stengade 11, 3000 Helsingør",
    placeholderTo: "Sct. Anna Gade 5, 3000 Helsingør",
    deliveryZones: ["3000 Helsingør", "3060 Espergærde", "3070 Snekkersten", "3140 Ålsgårde"],
    nearby: ["copenhagen", "roskilde"],
    useCases: [
      { t: "Ferry port deliveries", d: "Delivery to/from the Helsingør-Helsingborg ferry terminal." },
      { t: "Same-day to Copenhagen", d: "Helsingør → Copenhagen on 50 km — same-day from ~451 DKK." },
      { t: "Tourism & hospitality", d: "Discreet delivery for hotels, restaurants and tourism businesses." },
    ],
    faq: [
      { q: "How much is a Helsingør courier?", a: "Same-Day starts at 199 DKK (~€27) including 8 km. Local Helsingør deliveries typically 199-220 DKK." },
      { q: "Do you serve the Helsingør-Helsingborg ferry?", a: "Yes — pickup and drop-off at the ferry terminal is one of our most common routes." },
    ],
  },
};

export const EN_CITY_LIST = Object.values(EN_CITIES);
